// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-Giveaway-module__chatWindow-Fh5aZ {
  flex: 1;
}

.nightbot-Giveaway-module__giveawayPanel-YnHI6 {
  flex: 1;
}

.nightbot-Giveaway-module__giveawayDivider-PzeXY {
  display: none;
}

.nightbot-Giveaway-module__giveawayContainer-RflYl {
  flex: 1;
  display: flex;
  gap: 24px;
  max-height: 1000px;
}

@media (max-width: 1200px) {
  .nightbot-Giveaway-module__giveawayLayoutContainer-joDzZ {
    padding: 0px;
    gap: 0px;
    position: relative;
  }

  .nightbot-Giveaway-module__giveawayPanel-YnHI6 {
    background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
    background: initial;
    border: medium none currentcolor;
    border: initial;
    border-radius: 0;
    border-radius: initial;
    flex: none;
    width: 100%;
    scroll-snap-align: start;
  }

  .nightbot-Giveaway-module__giveawayHeading-mMS_U {
    display: none;
  }

  .nightbot-Giveaway-module__chatWindow-Fh5aZ {
    border: medium none currentcolor;
    border: initial;
    border-radius: 0;
    border-radius: initial;
    flex: none;
    width: 100%;
    scroll-snap-align: start;
  }

  .nightbot-Giveaway-module__giveawayFooter-UpC3X {
    display: none;
  }

  .nightbot-Giveaway-module__giveawayContainer-RflYl {
    gap: 0px;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
  }

  .nightbot-Giveaway-module__giveawayDivider-PzeXY {
    display: block;
    height: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Giveaway.module.scss"],"names":[],"mappings":"AAAA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,iFAAiB;IAAjB,mBAAiB;IACjB,gCAAa;IAAb,eAAa;IACb,gBAAoB;IAApB,sBAAoB;IACpB,UAAU;IACV,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gCAAa;IAAb,eAAa;IACb,gBAAoB;IAApB,sBAAoB;IACpB,UAAU;IACV,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,YAAY;EACd;AACF","sourcesContent":[".chatWindow {\n  flex: 1;\n}\n\n.giveawayPanel {\n  flex: 1;\n}\n\n.giveawayDivider {\n  display: none;\n}\n\n.giveawayContainer {\n  flex: 1;\n  display: flex;\n  gap: 24px;\n  max-height: 1000px;\n}\n\n@media (max-width: $mantine-breakpoint-lg) {\n  .giveawayLayoutContainer {\n    padding: 0px;\n    gap: 0px;\n    position: relative;\n  }\n\n  .giveawayPanel {\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    flex: none;\n    width: 100%;\n    scroll-snap-align: start;\n  }\n\n  .giveawayHeading {\n    display: none;\n  }\n\n  .chatWindow {\n    border: unset;\n    border-radius: unset;\n    flex: none;\n    width: 100%;\n    scroll-snap-align: start;\n  }\n\n  .giveawayFooter {\n    display: none;\n  }\n\n  .giveawayContainer {\n    gap: 0px;\n    overflow-x: scroll;\n    scroll-snap-type: x mandatory;\n  }\n\n  .giveawayDivider {\n    display: block;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatWindow": `nightbot-Giveaway-module__chatWindow-Fh5aZ`,
	"giveawayPanel": `nightbot-Giveaway-module__giveawayPanel-YnHI6`,
	"giveawayDivider": `nightbot-Giveaway-module__giveawayDivider-PzeXY`,
	"giveawayContainer": `nightbot-Giveaway-module__giveawayContainer-RflYl`,
	"giveawayLayoutContainer": `nightbot-Giveaway-module__giveawayLayoutContainer-joDzZ`,
	"giveawayHeading": `nightbot-Giveaway-module__giveawayHeading-mMS_U`,
	"giveawayFooter": `nightbot-Giveaway-module__giveawayFooter-UpC3X`
};
export default ___CSS_LOADER_EXPORT___;
